goog.provide("shadow.js.shim.module$date_fns$setDayOfYear$default");
shadow.js.shim.module$date_fns$setDayOfYear$default = shadow.js.require(203, {})["default"];
